import { CHECK_WSPOSITIONS, CHECK_WSPOSITIONS_SUCCESS, CHECK_WSPOSITIONS_ERROR} from './actionTypes';

const initialState = {
    errorCheckWsPositions: "",
    loadingCheckWsPositions: false,
    ws_positions: null,
    successWs: ""
}

const checkWsPositions = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_WSPOSITIONS:
            state = {
                ...state,
                loadingCheckWsPositions: true
            }
            break;
        case CHECK_WSPOSITIONS_SUCCESS:
            state = {
                ...state,
                loadingCheckWsPositions: false,
                ws_positions: action.payload.ws_positions, 
                successWs: action.payload.message
            }
            break;
        case CHECK_WSPOSITIONS_ERROR:
            state = { ...state, errorCheckWsPositions: action.payload, loadingCheckWsPositions: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default checkWsPositions;